// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_EnviarDadoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /implantacao/enviar_dado — o franqueado manda um item de dados para a conferência.
 * Item com formulário (dados_pessoais, dados_franquia, dados_bancarios): o servidor lê o que
 * está gravado e recusa se faltar campo obrigatório. Outro item de dados: vai `resposta`.
 */
import { registerContract } from './validate'

export interface Implantacao_EnviarDadoInput {
franquia_id?: number
item_chave?: string
resposta?: string
}

registerContract('Implantacao_EnviarDadoInput', {
  franquia_id: { type: 'number',  required: false },
  item_chave:  { type: 'string',  required: false },
  resposta:    { type: 'string',  required: false },
})
